"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGallery = exports.StyledFlexItem = exports.StyledFlexWrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var mixins_1 = require("../../../../themes/mixins");
var themes_1 = require("../../../../themes");
exports.StyledFlexWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  overflow: hidden;\n"], ["\n  display: flex;\n  overflow: hidden;\n"])));
exports.StyledFlexItem = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-shrink: 0;\n  width: 100%;\n  margin-left: ", ";\n  ", ";\n"], ["\n  flex-shrink: 0;\n  width: 100%;\n  margin-left: ", ";\n  ", ";\n"])), function (_a) {
    var marginLeft = _a.marginLeft;
    return marginLeft;
}, (0, mixins_1.transition)("margin-left"));
exports.StyledGallery = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-top: 1rem;\n  border-top: 2px solid ", ";\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"], ["\n  padding-top: 1rem;\n  border-top: 2px solid ", ";\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"])), function (_a) {
    var invert = _a.invert;
    return invert ? themes_1.colors.greyColor90 : themes_1.colors.greyColor5;
});
var templateObject_1, templateObject_2, templateObject_3;
